module.exports = __webpack_public_path__ + "static/media/music.160e2f7.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/music.mp3
// module id = lXnb
// module chunks = 0